'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSegment = exports.resetUser = exports.identify = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identify = exports.identify = function identify(id, userInfo) {
  window.analytics.identify(id, formatLogData(userInfo));
};

var resetUser = exports.resetUser = function resetUser() {
  window.analytics.reset();
};

var initSegment = exports.initSegment = function initSegment() {
  // Create a queue, but don't obliterate an existing one!
  var analytics = window.analytics || [];

  // If the real analytics.js is already on the page return.
  if (analytics.initialize) return;

  // If the snippet was invoked already show an error.
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.');
    }
    return;
  }

  // Invoked flag, to make sure the snippet
  // is never invoked twice.
  analytics.invoked = true;

  // A list of the methods in Analytics.js to stub.
  analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'];

  // Define a factory to create stubs. These are placeholders
  // for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is
  // stored as the first argument, so we can replay the data.
  analytics.factory = function (method) {
    return function () {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };

  // For each of our methods, generate a queueing stub.
  for (var index = 0; index < analytics.methods.length; index += 1) {
    var key = analytics.methods[index];
    analytics[key] = analytics.factory(key);
  }

  // Define a method to load Analytics.js from our CDN,
  // and that will be sure to only ever load it once.
  analytics.load = function (key, options) {
    // Create an async script element based on your key.
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://segment-middleware.stingray.com/load/' + key + '/stingraylytics.js';

    // Insert our script next to the first script element.
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  };

  // Add a version to keep track of what's in the wild.
  analytics.SNIPPET_VERSION = "4.13.2";
  analytics._writeKey = _config2.default.segmentKey;

  // Load Analytics.js with your key, which will automatically
  // load the tools you've enabled for your account. Boosh!
  analytics.load(_config2.default.segmentKey);

  window.analytics = analytics;
};

var flattenToSnakeCase = function flattenToSnakeCase(object, formatedObject) {
  (0, _keys2.default)(object).forEach(function (property) {
    var snakeProperty = '';
    if (property.includes('_')) {
      snakeProperty = property.toLowerCase();
    } else {
      snakeProperty = property.replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
        return '_' + y.toLowerCase();
      }).replace(/^_/, '');
    }

    if ((0, _typeof3.default)(object[property]) === 'object' && object[property] !== null) {
      flattenToSnakeCase(object[property], formatedObject);
    } else {
      switch (snakeProperty) {
        case 'email_address':
          formatedObject.email = object[property];
          break;
        default:
          formatedObject[snakeProperty] = object[property];
      }
    }
  });
};

var formatLogData = function formatLogData(unserInfo) {
  var formattedUserInfo = {};
  flattenToSnakeCase(unserInfo, formattedUserInfo);
  return formattedUserInfo;
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/SegmentLogs.js
// module id = 277
// module chunks = 0